import { render } from "./TermsOfServie.vue?vue&type=template&id=5b8e9a98"
import script from "./TermsOfServie.vue?vue&type=script&lang=js"
export * from "./TermsOfServie.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__